var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vehicle-rules-list"},_vm._l((_vm.fields),function(field){return _c('div',{key:field.key},[_c('svg-icon',{attrs:{"name":field.iconName}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(field.text))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }